import { useToggle } from "hooks";

const Slice = ({ children, limit, renderLess, renderMore }) => {
  const [open, toggleOpen] = useToggle();

  if (!children) return null;
  if (children.length < limit) return children;

  return (
    <>
      {children.slice(0, open ? children.length : limit)}
      <div onClick={toggleOpen}>{open ? renderLess : renderMore}</div>
    </>
  );
};

export default Slice;
